import { TSimulationType } from '@/types';
import { SCORE_LABELS } from '@/constants';

/**
 * Generates a subtitle message based the results of either a practice or final certification
 * simulation, providing context on the user's performance and next steps.
 *
 * @TODO remove when backend provides subtitles
 */
export function getScoreCardSubtitle(
  simulationType: TSimulationType,
  certificationTitle?: string,
  pass: boolean = false
): string | null {
  // If no score is available, return null
  if (!simulationType || !certificationTitle) return null;

  // For practice simulations, return a subtitle based on pass/fail status
  if (simulationType === 'practice') {
    return pass
      ? SCORE_LABELS.USER_PRACTICE_PASS_SUBTITLE
      : SCORE_LABELS.USER_PRACTICE_FAIL_SUBTITLE;
  }

  // For certification simulations, return a subtitle if the user passed, providing more context
  // on what it means to be certified. If they failed, we currently return a generic message, but
  // this can be expanded in the future to provide more specific feedback.
  if (simulationType === 'certification') {
    return pass
      ? SCORE_LABELS.USER_CERTIFICATION_PASS_SUBTITLE.replace(
          '%CERTIFICATION_TITLE%',
          certificationTitle,
        )
      : SCORE_LABELS.USER_CERTIFICATION_FAIL_SUBTITLE_1; // Currently, we only return the first part
  }

  return null;
}
